export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const ID_TOKEN_KEY = 'idToken';
export const USERNAME_KEY = 'username';
